
define('text!templates/appMain/privilegedMain/qm/policies/editors/agentSelectorNameList.html',[],function () { return '<!-- ko foreach: agents -->\n<div class="agent-name" data-bind="text: name"></div>\n<!-- /ko -->';});

